// LLM generated - Model Claude 4 Sonnet

// Pusher authentication types
export type PusherUserAuthPayload = {
  socket_id: string;
};

export type PusherUserAuthResponse = {
  auth: string;
  channel_data?: string;
};

export type PusherUserAuthSubscriptionsPayload = {
  socket_id: string;
  channel_name: string;
  // Optional fields that might be needed for presence channel auth
  auth?: string;
  user_data?: string;
};

export type PusherUserAuthSubscriptionsResponse = {
  auth: string;
  channel_data?: string;
  shared_secret?: string;
};

// Chat types
export type ChatChannel = {
  id: string;
  type: string;
  name: string;
  isPrivate: boolean;
};

export type ChatSettings = {
  muteNotifications: boolean;
};

export type Chat = {
  id: string;
  isEnabled: boolean;
  channels: ChatChannel[];
  permissions: string;
  mode: string;
  settings: ChatSettings;
  contestId: string;
  name: string;
};

export type GetChatsResponse = {
  page: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  id: string;
  data: Chat[];
};

export type UpdateChatPayload = {
  isEnabled: boolean;
};

export type UpdateChatAdministrationResponse = {
  id: string;
  data: Chat;
};

export type SendMessagePayload = {
  message: string;
  handle: string;
  header?: string;
  avatarUrl?: string;
};

export type SendMessageQuery = {
  notifyReaders?: boolean;
};

export type SendMessageResponse = {
  id: string;
  data: {
    id: string;
    publishedAt: string;
    payload: {
      message: string;
      header?: string;
    };
    user: {
      id: string;
      handle: string;
      avatarUrl?: string;
    };
    reactions: {
      code: string;
      count: number;
    }[];
    userReactions: string[];
    updatedAt: string;
    isPinned: boolean;
    splashMessage: boolean;
    deletedAt?: string;
  };
};

export type GetMessagesQuery = {
  page?: number;
  pageSize?: number;
  lastMessageId?: string;
  reversePageOrder?: boolean;
};

export type MessageReaction = {
  code: string;
  count: number;
};

export type MessageUser = {
  id: string;
  handle: string;
  avatarUrl?: string;
};

export type MessagePayload = {
  message: string;
  header?: string;
};

export type ChatMessage = {
  id: string;
  publishedAt: string;
  payload: MessagePayload;
  user: MessageUser;
  reactions: MessageReaction[];
  userReactions: string[];
  updatedAt: string;
  isPinned: boolean;
  splashMessage: boolean;
  mode?: 'unidirectional' | 'bidirectional';
  deletedAt?: string;
};

export type GetMessagesResponse = {
  page: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  id: string;
  data: ChatMessage[];
};

export type ChatMessagesInfiniteData = {
  pages: GetMessagesResponse[];
  pageParams: (string | undefined)[];
};

export type ChatUserSettings = {
  muteNotifications: boolean;
};

export type UpdateChatUserSettingsPayload = {
  muteNotifications: boolean;
};

export type GetChatsQuery = {
  contestId?: string;
  page?: number;
  pageSize?: number;
};

// Legacy Message type for compatibility
export type Message = {
  id: string;
  chatId: string;
  userId: string;
  content: string;
  messageType: 'user' | 'system' | 'splash';
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  isPinned: boolean;
  editedAt?: string;
  user?: {
    id: string;
    username: string;
    avatarUrl?: string;
  };
};

// Additional types for future endpoints
export type PublishMessagePayload = {
  content: string;
  messageType?: 'user' | 'system';
};

export type EditMessagePayload = {
  message: string;
  header?: string;
};

export type GetUnreadMessagesResponse = {
  id: string;
  data: {
    count: number;
  };
};

export type UnreadMessagesResponse = {
  id: string;
  data: {
    count: number;
  };
};

// eslint-disable-next-line no-restricted-syntax
export enum ReportReason {
  SPAM = 'spam',
  HARASSMENT = 'harassment',
  INAPPROPRIATE_CONTENT = 'inappropriate_content',
  HATE_SPEECH = 'hate_speech',
  OTHER = 'other',
}

export type FlagMessagePayload = {
  reason: ReportReason;
  description?: string;
};

export type Reaction = {
  code: string;
  url: string;
};

export type GetReactionsResponse = {
  id: string;
  data: Reaction[];
};

export type MessageReactionUser = {
  id: string;
  handle: string;
  avatarUrl: string;
};

export type MessageReactionData = {
  user: MessageReactionUser;
  reactionCodes: string[];
};

export type GetMessageReactionsQuery = {
  limit?: number;
  cursor?: string;
};

export type GetMessageReactionsResponse = {
  hasNextPage: boolean;
  nextCursor?: string;
  limit: number;
  id: string;
  data: MessageReactionData[];
};

export type AddReactionPayload = {
  code: string;
  handle: string;
  avatarUrl?: string;
};

export type StoreLastReadMessagePayload = {
  chatId: string;
  messageId: string;
};

export type HealthResponse = {
  status: 'ok' | 'error';
  timestamp: string;
  version?: string;
};

export type ChatWebFeatureFlagResponse = {
  chat: string;
  posts: string;
};
